var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_c('count-up',{attrs:{"startVal":_vm.startVal,"endVal":_vm.endVal,"duration":_vm.getText("duration"),"description":_vm.description,"sufix":_vm.sufix,"countItems":_vm.countItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }